import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Paper from 'material-ui/Paper';
import Popover from 'material-ui/Popover';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import AddIcon from 'material-ui/svg-icons/content/add';
import DropArrow from 'material-ui/svg-icons/navigation/arrow-drop-down';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import ArrowBackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import FolderIcon from 'material-ui/svg-icons/file/folder';
import CreateIcon from 'material-ui/svg-icons/content/create';
import Restore from 'material-ui/svg-icons/av/replay';
import DesktopMac from 'material-ui/svg-icons/hardware/desktop-mac';
import FileDownload from 'material-ui/svg-icons/file/file-download';
import LinkVariant from './LinkVariant';
import * as Colors from 'material-ui/styles/colors';
import { unselectAllImages, updateSearch } from 'MyAccount/ViewDesigns/redux/modules/images';
import { setWindowBusy } from 'MyAccount/ViewDesigns/redux/modules/general';
import {
  NAV_MENU_HEIGHT,
  NAV_MENU_HEIGHT_EDITOR,
  LEFT_MENU_WIDTH,
  DELETE_IMAGE_DIALOG,
  NEW_FOLDER_DIALOG,
  EDIT_INFO_IMAGE_DIALOG,
  UPLOAD_IMAGE_FROM_URL,
  IMAGE_PADDING,
  TRASH_FOLDER,
  UNSORTED_FOLDER,
  MAX_SIZE,
} from '../consts';
import { pushImageToBar } from 'MyAccount/ViewDesigns/redux/modules/images';
import {
  getSelectedImages,
  getFolderListNames,
  getCurrentFolderImages,
  createFilePathObject,
  isTrashFolder,
 } from '../selectors';
import RenameIcon from './RenameIcon';
import { openDialog, checkFileName, downloadImage } from '../helpers';
import { PANELS } from 'crazyEditor/components/ImageManagerDialogs/ImageManagerPanels';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import SearchField from 'shared/components/SearchField/SearchField';
import UploadImageToS3Button from 'shared/components/UploadImageToS3Button';
import { downsizeImage, checkImageSize } from 'MyAccount/ViewDesigns/helpers/uploadHelper';

const DROP_DOWN_MENU_HEIGHT = 35;
const DROP_DOWN_MENU_WIDTH = 180;

function getStyle({ integrated }) {
  return ({
    nav: {
      position: 'relative',
      height: integrated ? NAV_MENU_HEIGHT_EDITOR : NAV_MENU_HEIGHT,
      display: 'flex',
      alignItems: 'center',
      zIndex: 3,
      background: Colors.grey50,
    },
    searchBlock: {
      position: 'absolute',
      right: integrated ? 15 : 50,
      height: integrated ? 45 : 50,
      top: '50%',
      transform: 'translateY(-50%)',
      boxSizing: 'content-box',
      padding: '0px 0px 0px 50px'
    },
    dropDownComments: {
      whiteSpace: 'nowrap',
      color: Colors.grey500,
      fontSize: integrated ? '14px' : '16px',
    },
  });
}

const styles = {
  headerLeft: {
    width: LEFT_MENU_WIDTH,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    marginRight: IMAGE_PADDING,
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    heigth: '100%',
  },
  folderName: {
    whiteSpace: 'nowrap',
    marginLeft: 20,
  },
  dropDownBlock: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    heigth: '100%',
  },
  checkedMenu: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    background: Colors.grey50,
    display: 'flex',
    alignItems: 'center',
    zIndex: 10,
  },
  checkedButtons: {
    margin: '0 5px',
  },
  checkedButtonsLabel: {
    fontSize: '14px',
  },
  imagesAmount: {
    whiteSpace: 'nowrap',
    color: Colors.grey500,
    marginRight: 20,
  },
  deleteBlock: {
    position: 'absolute',
    right: 0,
    boxSizing: 'content-box',
  },
  deleteButton: {
    color: Colors.red700,
    minWidth: 120,
  },
  uploadButton: {
    height: DROP_DOWN_MENU_HEIGHT,
    lineHeight: `${DROP_DOWN_MENU_HEIGHT}px`,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.4)',
    width: DROP_DOWN_MENU_WIDTH,
    textAlign: 'center',
    marginRight: 24,
    backgroundColor: '#fff',
  },
  uploadLabel: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 14,
    fontWeight: 500,
    padding: 0,
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    display: 'none',
  },
  btnSpacing: {
    marginLeft: '24px',
  },
  floatingIcon: {
    float: 'right',
    margin: '6px 8px 6px -8px',
  },
  itemInner: {
    padding: '0px 16px 0px 50px',
  },
};

@connect(
  (state, props) => ({
    selectedImages: getSelectedImages(state),
    folderListNames: getFolderListNames(state, props.resourceType),
    photos: getCurrentFolderImages(state, props),
    // uploadFiles: state.images.Images.uploadFiles,
    isTrashFolder: isTrashFolder(props.currentFolder),
  }),
  { unselectAllImages, setWindowBusy, openLazyPanel, updateSearch,
    pushImageToBar }
)
export default class Header extends Component {
  static contextTypes = {
    imageUtils: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      error: '',
    };
  }

  getMoveToElements() {
    const { currentFolder, folderListNames } = this.props;
    const elements = [];
    if (currentFolder) {
      elements.push(
        <MenuItem
          key={999}
          primaryText={UNSORTED_FOLDER}
          onClick={this.moveTo.bind(this, '/')}
        />
      );
    }
    _.forEach(folderListNames, (folder, index) => {
      if (currentFolder !== folder && folder !== TRASH_FOLDER) {
        elements.push(
          <MenuItem
            key={index}
            primaryText={`${folder}`}
            onClick={this.moveTo.bind(this, folder)}
          />
        );
      }
    });
    return elements;
  }

  openImageInfoDialog = () => {
    const { integrated, openLazyPanel } = this.props;
    if (integrated) {
      openLazyPanel(PANELS.RENAME_IMAGE, null, null, { images: _.keys(this.props.selectedImages) });
    } else {
      openDialog({
        dialogName: EDIT_INFO_IMAGE_DIALOG,
        images: _.keys(this.props.selectedImages),
      });
    }
  };

  openDeleteImageDialog = () => {
    const { integrated, openLazyPanel, currentFolder } = this.props;
    if (integrated) {
      openLazyPanel(PANELS.DELETE_IMAGE, null, null, { images: _.keys(this.props.selectedImages), currentFolder });
    } else {
      openDialog({
        dialogName: DELETE_IMAGE_DIALOG,
        images: _.keys(this.props.selectedImages),
      });
    }
  };

  openNewFolderDialog = () => {
    const { integrated, openLazyPanel } = this.props;
    this.setState({ open: false });
    if (integrated) {
      openLazyPanel(PANELS.NEW_FOLDER, null, null, { images: _.keys(this.props.selectedImages) });
    } else {
      openDialog({
        dialogName: NEW_FOLDER_DIALOG,
        images: _.keys(this.props.selectedImages),
      });
    }
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  handleClick = (event) => {
    event.preventDefault();
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };


  moveTo = (newFolder) => {
    const { setWindowBusy, selectedImages } = this.props;
    this.setState({ open: false });
    newFolder = _.replace(newFolder, /\\/gi, '/');
    setWindowBusy(true);
    const selectedImagesKeys = _.keys(selectedImages);
    const files = _.map(selectedImagesKeys, (file) => {
      const folder = _.split(file, '/');
      const name = folder.pop();
      return {
        options: 'autorename',
        name,
        type: 'Images',
        folder: folder.join('/'),
      };
    });
    this.context.imageUtils.doMoveFiles({
      path: newFolder !== '/' ? `/${newFolder}/` : '/',
      files,
    }, (data) => {
      const response = data && data.responseJSON;
      setWindowBusy(false);
      if (response && response.error && response.error.message) {
        // todo show error
        this.setState({ error: response.error.message });
      } else {
        this.handleRequestClose();
      }
    });
  };

  restoreFromTrash = () => {
    const { setWindowBusy, selectedImages } = this.props;
    this.setState({ open: false });
    setWindowBusy(true);
    const selectedImagesKeys = _.keys(selectedImages);
    const files = _.map(selectedImagesKeys, (file) => {
      const folder = _.split(file, '/');
      const name = folder.pop();
      return {
        options: 'autorename',
        name,
        type: 'Images',
        folder: folder.join('/'),
      };
    });
    this.context.imageUtils.doRestoreFromTrash({
      files,
    }, (data) => {
      const response = data && data.responseJSON;
      setWindowBusy(false);
      if (response && response.error && response.error.message) {
        // todo show error
        this.setState({ error: response.error.message });
      } else {
        this.handleRequestClose();
      }
    });
  };

  currentFolderCheck() {
    const { currentFolder } = this.props;
    return currentFolder.length > 19 ? `${currentFolder.slice(0, 18)}...` : currentFolder;
  }

  deleteImage = () => {
    const { isTrashFolder } = this.props;
    if (isTrashFolder) {
      return this.openDeleteImageDialog();
    }
    this.moveToTrashFolder();
  };

  moveToTrashFolder = () => {
    const { setWindowBusy } = this.props;
    setWindowBusy(true);
    const images = _.keys(this.props.selectedImages);
    const files = _.map(_.isArray(images) ? images : [images], (file) => {
      let folder = _.split(file, '/');
      const name = folder.pop();
      folder = folder.join('/');
      return {
        options: 'autorename',
        name,
        type: 'Images',
        folder: folder ? `${folder}/` : '/',
      };
    });
    this.context.imageUtils.doMoveToTrash({
      files,
    }, (data) => {
      const response = data && data.responseJSON;
      if (response && response.error && response.error.message) {
        // todo show error
        this.setState({ error: response.error.message });
      }
      setWindowBusy(false);
    });
  };

  inputClick = () => {
    this.refs.file.click();
  };

  updateSearch = (search) => {
    this.props.updateSearch({ search });
  };

  downloadImages = () => {
    const { photos, selectedImages } = this.props;
    _.map(photos, item => {
      const itemUrl = item.path + item.name;
      if (selectedImages[itemUrl]) {
        downloadImage(item.name, item.url);
      }
    });
  };

  render() {
    const { selectedImages, unselectAllImages, currentFolder, integrated, resourceType, folderListNames, type, uploadImagesDirectToEditor, openIntegratedUploadFromUrlDialog } = this.props;
    const selectedImagesCount = _.size(selectedImages);
    const dynStyles = getStyle({ integrated });
    const defaultFolderName = resourceType === 'Icons' ? folderListNames[0] : UNSORTED_FOLDER;
    return (
      <Paper rounded={false} style={dynStyles.nav}>
        <div style={styles.headerLeft}>
          <div style={styles.folderName}>
            {typeof currentFolder !== 'undefined' ? this.currentFolderCheck() : defaultFolderName}
          </div>
        </div>
        <div
          style={styles.headerRight}
        >
          { resourceType !== 'Icons' && <div
            style={styles.dropDownBlock}
          >
            {
            /* hide until implementation drag n' drop
             <div style={dynStyles.dropDownComments}>Upload or drag n' drop images</div>
             */
            }
            { currentFolder !== TRASH_FOLDER &&
            <UploadImageToS3Button
              style={{margin: 20}}
              resourceType={resourceType}
              currentFolder={currentFolder}
              uploadImagesDirectToEditor={uploadImagesDirectToEditor}
              integrated={integrated}
              type={type}
              openIntegratedUploadFromUrlDialog={openIntegratedUploadFromUrlDialog}
            />}
          </div>
          }
          <div
            style={dynStyles.searchBlock}
          >
            <SearchField
              hintText="Search images"
              onChange={this.updateSearch}
              style={{ width: 300 }}
            />
          </div>
        </div>
        { selectedImagesCount > 0 && resourceType !== 'Icons' &&
          <div style={styles.checkedMenu}>
            <div style={styles.headerLeft}>
              <FlatButton
                label="BACK"
                icon={<ArrowBackIcon />}
                style={styles.checkedButtons}
                labelStyle={styles.checkedButtonsLabel}
                onClick={unselectAllImages}
              />
            </div>
            <div
              style={styles.headerRight}
            >
              <div
                style={styles.dropDownBlock}
              >
                <div style={styles.imagesAmount}>{selectedImagesCount} selected</div>
              { currentFolder === TRASH_FOLDER ?
                <FlatButton
                  label="RESTORE FROM TRASH"
                  icon={<Restore />}
                  onClick={this.restoreFromTrash}
                  style={{...styles.checkedButtons, ...styles.btnSpacing}}
                  labelStyle={styles.checkedButtonsLabel}
                />
                : <FlatButton
                  label="MOVE TO"
                  icon={<FolderIcon/>}
                  onClick={this.handleClick}
                  style={{...styles.checkedButtons, ...styles.btnSpacing}}
                  labelStyle={styles.checkedButtonsLabel}
                >
                  <DropArrow style={styles.floatingIcon} color={Colors.grey700}/>
                </FlatButton>
              }
                {//  selectedImagesCount < 2 && currentFolder !== TRASH_FOLDER &&
                  // <FlatButton
                  // label="CROP & EDIT"
                  // icon={<CreateIcon />}
                  // style={styles.checkedButtons}
                  // labelStyle={styles.checkedButtonsLabel}
                  // onClick={this.openFeatherEditor}
                  // />
                }
              { selectedImagesCount < 2 && currentFolder !== TRASH_FOLDER &&
                <FlatButton
                  label="Rename"
                  icon={<RenameIcon />}
                  style={styles.checkedButtons}
                  labelStyle={styles.checkedButtonsLabel}
                  onClick={this.openImageInfoDialog}
                />
              }
                <FlatButton
                  label="Download"
                  icon={<FileDownload />}
                  style={styles.checkedButtons}
                  labelStyle={styles.checkedButtonsLabel}
                  onClick={this.downloadImages}
                />
              </div>
              <div style={styles.deleteBlock}>
              <FlatButton
                label={currentFolder === TRASH_FOLDER ? 'DELETE FOREVER' : 'DELETE'}
                icon={<DeleteIcon />}
                style={styles.deleteButton}
                labelStyle={styles.checkedButtonsLabel}
                onClick={this.deleteImage}
              />
              </div>
            </div>
          </div>
        }
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{horizontal: 'left', vertical: 'top'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          onRequestClose={this.handleRequestClose}
        >
          <Menu>
            <MenuItem primaryText="Move to:" disabled />
            {this.getMoveToElements()}
            <Divider />
            <MenuItem
              innerDivStyle={styles.itemInner}
              primaryText="NEW FOLDER"
              leftIcon={<AddIcon />}
              onClick={this.openNewFolderDialog}
            />
          </Menu>
        </Popover>
      </Paper>
    );
  }
}

Header.PropTypes = {
  selectedImages: PropTypes.arrayOf(PropTypes.number),
  unselectAllImages: PropTypes.func,
  currentFolder: PropTypes.string,
};